import { Component } from '@angular/core';

import { WidgetsModule } from '../../widgets/widgets.module';

@Component({
  selector: 'app-adviser-options-screen',
  imports: [WidgetsModule],
  templateUrl: './adviser-options-screen.component.html',
  styleUrls: ['./adviser-options-screen.component.scss'],
})
export class AdviserOptionsScreenComponent {}
// TODO: PAGE NOT IN USE YET
